import store from "@/store"

export default function superadmin_specialist({ next, router }) {
    if(!store || !store.state.auth.isLogged || !['superadmin', 'supermanager', 'tech_specialist'].includes(store.state.auth.user.role)) {
        router.push('/admin/login')
        return
    }
    return next()
}
